import React, { useEffect, useState } from 'react'
import { loadFacebookSDK } from '../../lib/facebook-sdk'
import useGetSocialAppId from '@/services/api/auth/useGetSocialAppId'
// Current primary "f" logo from Meta's Facebook Brand Asset Pack, unaltered.
import facebookLogo from '@/assets/images/facebook/facebook-logo-primary.png'
import { Button } from '@/components/ui/button'
import useLogin from '@/services/api/auth/useLogin'
import { socialButtonClass, socialLogoClass } from './socialSignInStyles'

export default function FacebookLoginButton({
  isLoading,
  setIsLoading,
  onSuccess,
  label = 'Sign in with Facebook',
}: {
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
  onSuccess: () => void
  label?: string
}) {
  const { login, loginStatus } = useLogin()
  const [sdkLoaded, setSdkLoaded] = useState(false)
  const { data: fbData, isLoading: isLoadingFb } = useGetSocialAppId({
    platform: 'facebook',
  })
  const appId = fbData?.platform_id

  useEffect(() => {
    if (appId) {
      loadFacebookSDK(appId).then(() => {
        setSdkLoaded(true)
      })
    }
  }, [appId])

  const handleFacebookLogin = (e) => {
    if (!window.FB) return
    setIsLoading(true)

    window.FB.login(
      (response) => {
        if (response?.status === 'connected' && response?.authResponse) {
          const { accessToken } = response.authResponse

          login({ platform: 'facebook', accessToken })
            .then(() => {
              onSuccess()
            })
            .finally(() => {
              setIsLoading(false)
            })
        } else {
          console.error('Facebook login failed')
          setIsLoading(false)
        }
      },
      { scope: 'public_profile,email' },
    )
  }

  return (
    <Button
      onClick={handleFacebookLogin}
      disabled={!sdkLoaded}
      variant="outline"
      size="lg"
      className={socialButtonClass}
      loading={isLoading}
    >
      <img
        src={facebookLogo}
        alt=""
        aria-hidden="true"
        className={socialLogoClass}
      />
      <span>{label}</span>
    </Button>
    // <button onClick={handleFacebookLogin} disabled={!sdkLoaded}>
    //   Login with Facebook
    // </button>
  )
}
